import { FeatureToggleConfig } from "@kode-frontend/feature-toggle-react";

import { defaultFlags } from "./default-flags";

export const featureToggleConfig = new FeatureToggleConfig({
  defaultFlags,
  storage: {
    getItem: localStorage.getItem.bind(localStorage),
    setItem: localStorage.setItem.bind(localStorage),
  },
  storageKey: `kex-web.platform.ft_${APP_VERSION}`,
});
